import styles from '@/styles/global/tabbar.module.scss'
import { ReactNode, useRef, useEffect, useState } from 'react'

interface TabItem {
  id: number
  name: string
  itemWidth?: string
  reactNode?: ReactNode
}

interface Props {
  activeTab: number
  tabItemRightMargin?: string
  tabList: TabItem[]
  onTabChange: (_index: number) => void
  recordId?: (_index: number | string) => void
}

export default function TabBar({
  tabList,
  activeTab,
  tabItemRightMargin,
  onTabChange,
  recordId
}: Props) {

  const tabRefs = useRef<(HTMLDivElement | null)[]>([])
  const [triangleLeft, setTriangleLeft] = useState(0)

  // 计算三角形位置
  useEffect(() => {
    const el = tabRefs.current[activeTab]
    if (el) {
      const { offsetLeft, offsetWidth } = el
      setTriangleLeft(offsetLeft + offsetWidth / 2)
    }
  }, [activeTab])

  const handleTabClick = (index: number, id: number | string) => {
    onTabChange(index)
    recordId?.(id)
  }

  return (
    <div className={styles['tab-box']}>
      <div className={styles['tab-list']}>

        {tabList.map((item, index) => (
          <div
            key={index}
            ref={(el: HTMLDivElement | null) => { tabRefs.current[index] = el }}
            className={`${styles['tab-item']} ${
              index === activeTab ? styles['active'] : ''
            }`}
            style={{
              width: item.itemWidth || 'auto',
              paddingRight: tabItemRightMargin || '16px'
            }}
            onClick={() => handleTabClick(index, item.id)}
          >
            {item.reactNode ? (
              item.reactNode
            ) : (
              <div className={styles['tab-name']}>{item.name}</div>
            )}
          </div>
        ))}
        {/* <div style={{ flex: 1, paddingRight: 0 }} className={styles['tab-item']}>
          <div className={styles['tab-name']}>&nbsp;</div>
        </div> */}

        <div
          className={styles['tab-active-instruct']}
          style={{
            transform: `translateX(${triangleLeft}px)`
          }}
        />
      </div>
    </div>
  )
}
